export const TRACKING_CATEGORY = 'Service';

export const TRACKING_ACTION = 'Auftragsstatus';
